<template>
  <div id="detailed-cart">
    <SfModal :title="$t('select_gift')" v-if="msOpen" :visible="msOpen" cross overlay transitionModal="sf-fade"
      transitionOverlay="sf-fade" :persistent="false" class="mansongItem">
      <template #modal-bar>
        <div class="title" style="text-align:center;">
          <h4 style="padding:2rem;padding-top:1rem;margin:0;padding-bottom:0;">{{ $t('select_gift') }}</h4>
        </div>
      </template>
      <template #close>
        <div></div>
      </template>
      <template #default>
        <div style="height: 70vh" class="item-list">
          <SfProductCard v-for="goods in gift_goods" :key="goods.good_id" :image="goods.imageUrl" imageWidth="100"
            imageHeight="100" :title="goods.title" :wishlistIcon="false" isInWishlistIcon="heart_fill">
            <template #price>
              <div style="min-height: 30px">
                <Sku :goodInfo="goods" :showBtn="false" :showMs="true" @changeSelectedSku="changeSelectedSku"
                  @backSku="clickMsItem" hidePost />
              </div>
            </template>
          </SfProductCard>
        </div>
      </template>
    </SfModal>
    <OrderSummary :orderTitle="$t('Promo_code')" :orderTitleLevel="2" :order="order" :propertiesNames="[
      'Products',
      'Total',
      'Shipping',
      ('Shipping_Tax'),
      'payment_insurance_fee',
      'payment_insurance_tax',
      'payment_order_discount',
      ('Total_price'),
    ]" @click:apply-code="clickCode" ref="code">
      <template #characteristics>
        <div v-if="promoCode && promoCode.length && false">
          <div style="font-weight: 600;margin-bottom:0.5rem;">{{ $t('currentUseCode') }}:</div>
          <div v-for="(code, key) in promoCode" :key="key" class="codeList"
            style="display: flex;align-items: center;margin-bottom:0.5rem;">
            <div style="border: 1px solid #000;padding:4px;">
              <SfIcon style="height:16px;width:16px;" aria-hidden="true" color="green-primary" size="xs" icon="cross"
                @click="delCode(code)" />
            </div>
            <div style="flex: 1;margin-left:1rem;">{{ code }}</div>
          </div>
        </div>
        <div>
          <div v-if="couponList && couponList.length > 0" style="font-weight: 600;margin:0.5rem 0;">{{ $t('CouponCode') }}:</div>
          <div v-for="coupone in couponList" style="margin-bottom:0.5rem;">
            <SfCheckbox v-e2e="'coupons'" v-model="coupons" name="coupons" class="summary__terms"
              :value="coupone.promotion_code" @change="selecCouponeChange(coupone)">
              <template #label>
                <div style="margin-left:1rem;">
                  {{ coupone.promotion_code }}
                </div>
              </template>
            </SfCheckbox>
          </div>
        </div>
        <div style="border-bottom:1px solid #ccc;margin-top:1rem;"></div>
        <SfCharacteristic v-for="characteristic in icons" :key="characteristic.title" :title="$t(characteristic.title)"
          :description="$t(characteristic.description)" :icon="characteristic.icon" size-icon="32px"
          color-icon="green-primary" class="sf-order-summary__characteristics-item" />
      </template>
    </OrderSummary>
    <div v-if="payImage">
      <img :src="payImage" />
    </div>
  </div>
</template>
<script>
// import { onSSR } from '@vue-storefront/core';
import {
  SfModal,
  SfProductCard,
  SfCharacteristic,
  SfIcon,
  SfCheckbox
} from '@storefront-ui/vue';
import { useOCart, usePreviewOrder, useMakeOrder, orderGetters, useBenefitCode, useBenbefitCodeList } from '@bee-hole/coms';
import {
  computed,
  watch,
  onUnmounted,
  ref,
  useRoute,
  onMounted
} from '@nuxtjs/composition-api';
import Sku from '~/components/Sku/Sku';
import OrderSummary from '~/components/Checkout/OrderSummary';
import { usePreviewOrderStore } from '~/stores/previewOrder';
import { EventBus } from '@/plugins/eventBus';
export default {
  name: 'CartPreview',
  components: {
    OrderSummary,
    SfModal,
    SfProductCard,
    Sku,
    SfCharacteristic,
    SfIcon,
    SfCheckbox
  },
  setup(props, context) {
    const route = useRoute();
    const { cart } = useOCart();
    const { order: finalOrder } = useMakeOrder();
    const { getCodelist, list } = useBenbefitCodeList();
    const msOpen = ref(false);
    const gift_goods = ref();
    const payImage = computed(() => {
      if (finalOrder?.value?.native_prepay?.native_code) {
        return 'data:image/jpeg;base64, ' + finalOrder?.value?.native_prepay?.native_code;
      }
    });

    const { preview, preorder } = usePreviewOrder();
    const previewOrderStore = usePreviewOrderStore();
    const { addCode, result, error: codeErr } = useBenefitCode();
    // const cartNumUpdateStatus = ref(false);
    // const address = computed(() => previewOrderStore.address);
    // const builing = computed(() => previewOrderStore.builing);
    // const previewId = computed(() => previewOrderStore.preview_id);
    // const IdCard = computed(() => previewOrderStore.IdCard);
    // const hasInsurance = computed(() => previewOrderStore.hasInsurance);
    // const coupons = ref([]);
    const coupons = computed(()=>preorder?.value?.promoCodes || []);
    const promoCode = computed(() => preorder?.value?.promoCodes);
    // const shippingMethods = computed(() => previewOrderStore?.shippingMethods);
    const code = ref();
    const currentCode = ref('');
    const couponList = computed(() => {
      // 去掉list数组中promotion_code相等的
      const couponsList = [];
      if (list.value && list.value?.length) {
        list.value?.map((item) => {
          if (couponsList.findIndex(coupon => coupon?.promotion_code === item?.promotion_code) === -1) {
            couponsList.push(item);
          }
        });
      }
      return couponsList;
    });
    const order = computed(() => {
      // const order = preorder?.value?.orders?.[0];
      // console.log(' preorder?.value?.', preorder?.value);
      // return order ? orderGetters.getOrderSummaryOrder(order) : {};
      return preorder?.value?.orders?.length ? orderGetters.getOrderListSummaryOrder(preorder?.value) : {};
    });
    // 预览订单商品列表
    // const shoppingList = (() => {
    //   const list = [];
    //   cart?.value?.list?.map((item) => {
    //     const sku = {
    //       sku_id: item.skuId,
    //       num: item.num,
    //       sku_prop: item.properties,
    //       activity_id: ''
    //     };
    //     if (previewOrderStore.services?.[item.skuId]) {
    //       sku.service_ids = previewOrderStore.services[item.skuId];
    //     }
    //     list.push(sku);
    //   });
    //   return list;
    // });
    // const initShouHuo = () => {
    //   if (!previewOrderStore.shippingMethods || !previewOrderStore.shippingMethods || previewOrderStore.shippingMethods?.length === 0) {
    //     // console.log('preorder?.value?.orders', preorder?.value);
    //     preorder?.value?.orders.map((order) => {
    //       if (order?.express?.carryId && order?.shop?.shopId) {
    //         previewOrderStore.setShippingMethod({
    //           carry_id: order.express.carryId,
    //           shop_id: order.shop.shopId
    //         });
    //       }
    //     });
    //   }
    // };
    const preOrderAdd = async () => {
      // if (!address?.value?.addressId) {
      //   return;
      // }
      // if (loading?.value) {
      //   console.error('购物车', loading.value, cart.value);
      //   return;
      // }
      // previewOrderStore.initPreviewKey();
      // // if (!paymethod?.value?.payWayId) {
      // //   console.log('没有支付参数');
      // //   return;
      // // }
      // const userKey = context?.root?.$cookies.get("userKey")
      // const tokenkey = context?.root?.$cookies.get("tokenkey")
      // const data = {
      //   address_id: address?.value?.addressId,
      //   fx_id: '0',
      //   from_id: tokenkey,
      //   member_note: '',
      //   shopping_list: shoppingList(),
      //   combine_pay: true,
      //   billing_address_id: builing.value?.addressId,
      //   has_insurance: hasInsurance.value
      // };
      // if (userKey) {
      //   data.user_id = userKey;
      // }
      // if (previewOrderStore?.previewKey) {
      //   data.preview_serial_id = previewOrderStore?.previewKey;
      // }
      // if (previewOrderStore.shippingMethods && preorder.value && previewOrderStore.shippingMethods.length === preorder.value?.orders?.length) {
      //   data.express = previewOrderStore.shippingMethods;
      // }
      // if (previewId?.value && !cartNumUpdateStatus.value) {
      //   data.preview_id = previewId?.value;
      // }
      // // if (promoCode?.value) {
      // //   data.promo_code = promoCode?.value;
      // // }
      // if (previewOrderStore?.IdCard && previewOrderStore?.IdCard?.id_number && previewOrderStore?.IdCard?.id_name) {
      //   data.id_name = previewOrderStore.IdCard.id_name;
      //   data.id_number = previewOrderStore.IdCard.id_number;
      //   data.id_type = previewOrderStore.IdCard.id_type;
      // } else if (preorder?.value?.hasIdentityCheck && (previewOrderStore?.IdCard?.id_type || previewOrderStore?.IdCard?.id_number || previewOrderStore?.IdCard?.id_name)) {
      //   // return false;
      // }
      // if (!preorder?.value?.expressChart || preorder?.value?.expressChart?.length === 0) {
      //   console.log('清空预览订单的物流方式');
      //   previewOrderStore.clearShippingMethods();
      // }
      // // console.log(previewId?.value, code.value);
      // await preview(data);
      // initShouHuo();
      // // previewOrderStore.setPrepay_id(preorder?.value?.previewId);
      // previewOrderStore.setPreview_id(preorder?.value?.previewId);
      // cartNumUpdateStatus.value = false;
    };

    // 离开checkout页面清除previewKey
    onUnmounted(() => {
      if (route.value?.path?.indexOf('/checkout') === -1) {
        previewOrderStore.clearpreviewId();
        previewOrderStore.clearCode();
        previewOrderStore.clearPreviewKey();
        // console.log('清除预览id', previewOrderStore.state);
      } else {
        // console.log('还在预览页不清除预览id');
      }
    });
    // watch([() => cart?.value?.list, () => address.value, () => builing.value, () => IdCard.value, () => shippingMethods.value, () => hasInsurance.value, () => previewOrderStore.servicesUpdate], async (newVal, oldVal) => {
    //   if (newVal?.length) {
    //     if (JSON.stringify(newVal[0]) !== JSON.stringify(oldVal[0])) {
    //       cartNumUpdateStatus.value = true;
    //     }
    //   }
    //   if ((newVal[0] && newVal[0].length)) {
    //     if (JSON.stringify(newVal[0]) !== JSON.stringify(oldVal[0]) && JSON.stringify(newVal[0])) {
    //       preOrderAdd();
    //       return false;
    //     }
    //     if (JSON.stringify(newVal[1]) !== JSON.stringify(oldVal[1]) && newVal[1]) {
    //       preOrderAdd();
    //       return false;
    //     }
    //     if (JSON.stringify(newVal[2]) !== JSON.stringify(oldVal[2]) && newVal[2]) {
    //       preOrderAdd();
    //       return false;
    //     }
    //     if (newVal?.[3].is_update && newVal?.[3].id_number && newVal?.[3].id_name) {
    //       preOrderAdd();
    //       previewOrderStore.setIsUpdate(false);
    //       return false;
    //     }
    //     if (previewOrderStore?.isShippingUpdate) {
    //       previewOrderStore.clearShippingUpdate();
    //       preOrderAdd();
    //       return false;
    //     }
    //     if (JSON.stringify(newVal[5]) !== JSON.stringify(oldVal[5])) {
    //       if (previewOrderStore.hasInsuranceUpdate) {
    //         preOrderAdd();
    //         previewOrderStore.sethasInsuranceUpdate(false);
    //         return false;
    //       }
    //     }
    //     if (previewOrderStore.servicesUpdate) {
    //       preOrderAdd();
    //       previewOrderStore.setServicesUpdate(false);
    //       return false;
    //     }
    //   }
    // }, { deep: true, immediate: true });
    const chuliGiftItem = () => {
      if (result.value?.promo_details && result.value?.promo_details?.length && result.value.promo_details[0].gift_goods && result.value.promo_details[0].gift_goods?.length) {
        gift_goods.value = result.value?.promo_details?.[0]?.gift_goods;
        // console.log('mansong', result.value?.promo_details?.[0]);
        msOpen.value = true;
      }
    };
    const pushCode = async (code) => {
      if (code) {
        await addCode({
          promotion_code: code.promoCode,
          adv_pay_id: preorder.value?.previewId,
          operate: 'use',
          preview_serial_id: previewOrderStore?.previewKey
        });
        if (codeErr.value === null) {
          previewOrderStore.setPromo_code(code.promoCode);
        }
        currentCode.value = code;
        EventBus.$emit('PreviewOrder', code);
        chuliGiftItem();
        return code;
        // console.log('value?.previewId code', result);
      }
    };
    const clickCode = async () => {
      if (code.value._data) {
        pushCode(code.value._data);
        preOrderAdd();
        // chuliGiftItem();
        // console.log('value?.previewId code', result);
      }
    };
    const autoPushBenefitCode = async () => {
      const codes = [];
      if (list.value?.length) {
        // 循环list 每一秒执行一次pushCode 同步执行
        list.value.map((item) => {
          if (item.benefit_type !== 3) {
            codes.push(item?.promotion_code);
          }
        });
        await addCode({
          promotion_code: codes,
          adv_pay_id: preorder.value?.previewId,
          operate: 'use',
          preview_serial_id: previewOrderStore?.previewKey
        });
        if (codeErr.value === null) {
          previewOrderStore.setPromo_codes(codes);
        }
        // currentCode.value = code;
        setTimeout(() => {
          chuliGiftItem();
          preOrderAdd();
          EventBus.$emit('PreviewOrder', codes);
        }, 200);
      }
    };
    // loadCart();
    onMounted(async () => {
      // await loadCart();
      await getCodelist();
      if (route.value?.path?.indexOf('/checkout/payment') !== -1) {
        if (!previewOrderStore?.isAutoPromoCodePush && previewOrderStore?.previewKey) {
          previewOrderStore.setisAutoPromoCodePush(true);
          autoPushBenefitCode();
        }
      } else {
        previewOrderStore.setisAutoPromoCodePush(false);
      }
      // 页面刷新的时候清除previewKey
      window.onbeforeunload = () => {
        // console.log('页面刷新的时候清除previewKey');
        previewOrderStore.clearPreviewKey();
      };
      if (!previewOrderStore?.previewKey) {
        // preOrderAdd();
      }
    });

    const changeSelectedSku = () => {
      // console.log('changeSelectedSku', res);
    };
    const clickMsItem = async (item) => {
      // console.log('clickMsItem', item);
      await addCode({
        promotion_code: currentCode.value.promoCode,
        adv_pay_id: preorder.value?.previewId,
        operate: 'use',
        gift_items_summary: [{
          good_id: item.goodId,
          sku_id: item.sku.skuId,
          title: item.title,
          img_url: item.imageUrl,
          // sku_prop: item.sku_prop,
          num: 1
        }],
        preview_serial_id: previewOrderStore?.previewKey
      });
      EventBus.$emit('PreviewOrder', code.value._data.promoCode);
      msOpen.value = false;
      preOrderAdd();
    };
    const delCode = async (code) => {
      previewOrderStore.delCode(code);
      await addCode({
        promotion_code: code,
        adv_pay_id: preorder.value?.previewId,
        operate: 'del',
        preview_serial_id: previewOrderStore?.previewKey
      });
      preOrderAdd();
      EventBus.$emit('PreviewOrder', code);
    };
    const selecCouponeChange = async (coupon) => {
      if (coupon?.promotion_code) {
        if (coupons.value && coupons.value.indexOf(coupon?.promotion_code) === -1) {
          await pushCode({ promoCode: coupon?.promotion_code });
          chuliGiftItem();
          preOrderAdd();
          EventBus.$emit('PreviewOrder', coupon?.promotion_code);
        } else {
          delCode(coupon?.promotion_code);
        }
      }
    };
    return {
      order,
      payImage,
      clickCode,
      code,
      msOpen,
      gift_goods,
      changeSelectedSku,
      clickMsItem,
      icons: [
        {
          title: 'cartPreviewSafety',
          description: 'cartPreviewSafety_messageinfo',
          icon: 'safety'
        },
        {
          title: 'cartPreviewShipping',
          description:
            'cartpreviewShipping_messageinfo',
          icon: 'shipping'
        }
        // ,{
        //   title: 'Changed your mind?',
        //   description: 'Rest assured, we offer free returns within 30 days',
        //   icon: 'return'
        // }
      ],
      delCode,
      promoCode,
      coupons,
      couponList,
      selecCouponeChange
    };
  }
};
</script>
<style lang="scss" scoped>
#detailed-cart {
  box-sizing: border-box;

  @include for-desktop {
    max-width: 360px;
    margin: 0 auto;
    background-color: var(--c-light);
    padding: var(--spacer-xl);
  }
}

.item-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>
<style lang="scss">
.mansongItem {
  .sf-modal__container {
    width: 100vw;
  }
}

.couponeModal1 {
  .sf-modal__container {
    width: 300px;

    @include for-mobile {
      --modal-left: calc((100vw - 300px)/2);
      --modal-height: 300px !important;
      --modal-top: 5rem;
    }
  }
}

.codeList {
  display: flex;
}
</style>
